import _regeneratorRuntime from "/var/www/sellox-gatsby-shop/node_modules/@babel/runtime/regenerator/index.js";
import { __awaiter } from "tslib";
import { CONFIG } from "./core";
export var Api = {
  token: "",
  post: function post() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch(url, {
                method: "POST",
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "".concat(this.token),
                  $shopKey: CONFIG.shop.$key
                },
                redirect: "follow",
                referrer: "no-referrer",
                body: JSON.stringify(Object.assign(Object.assign({}, data), {
                  $shopKey: CONFIG.shop.$key
                }))
              });

            case 2:
              res = _context.sent;

              if (res.ok) {
                _context.next = 5;
                break;
              }

              throw new Error("Network response was not ok.");

            case 5:
              return _context.abrupt("return", res.json());

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
  }
};
export default Api;